var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwoPiecesTrayBox = function SvgTwoPiecesTrayBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "614.0mm",
    height: "298.0mm",
    viewBox: "0.0 0.0 614.0 298.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 209,
    y1: 1,
    y2: 1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 160,
    y1: 1,
    y2: 91,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 160,
    y1: 97,
    y2: 91,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    x2: 209,
    y1: 0,
    y2: 1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 404,
    x2: 210,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 405,
    y1: 1,
    y2: 1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 454,
    y1: 1,
    y2: 91,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 454,
    y1: 97,
    y2: 91,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 610,
    x2: 511,
    y1: 101,
    y2: 101,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 454,
    y1: 99,
    y2: 97,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 511,
    x2: 507,
    y1: 101,
    y2: 99,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 610,
    x2: 610,
    y1: 101,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 614,
    x2: 610,
    y1: 133.33333333333334,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 614,
    x2: 614,
    y1: 133.33333333333334,
    y2: 164.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 610,
    x2: 614,
    y1: 165.66666666666669,
    y2: 164.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 610,
    x2: 610,
    y1: 165.66666666666669,
    y2: 197,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 511,
    x2: 610,
    y1: 197,
    y2: 197,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 507,
    x2: 511,
    y1: 199,
    y2: 197,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 454,
    y1: 207,
    y2: 201,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 454,
    y1: 199,
    y2: 201,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 454,
    x2: 454,
    y1: 207,
    y2: 297,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 405,
    x2: 454,
    y1: 297,
    y2: 297,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 404,
    x2: 405,
    y1: 298,
    y2: 297,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    x2: 404,
    y1: 298,
    y2: 298,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 160,
    y1: 207,
    y2: 297,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 209,
    x2: 160,
    y1: 297,
    y2: 297,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    x2: 209,
    y1: 298,
    y2: 297,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 160,
    y1: 201,
    y2: 207,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 160,
    y1: 199,
    y2: 201,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    x2: 107,
    y1: 199,
    y2: 199,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 103,
    y1: 197,
    y2: 197,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 107,
    x2: 103,
    y1: 199,
    y2: 197,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 4,
    y1: 197,
    y2: 165.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 4,
    y1: 164.66666666666669,
    y2: 165.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 133.33333333333334,
    y2: 164.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 0,
    y1: 132.33333333333334,
    y2: 133.33333333333334,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 4,
    y1: 101,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 4,
    y1: 101,
    y2: 101,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 107,
    x2: 103,
    y1: 99,
    y2: 101,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 160,
    y1: 97,
    y2: 99,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    x2: 107,
    y1: 99,
    y2: 99,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 209,
    x2: 207,
    y1: 100,
    y2: 99,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    x2: 211,
    y1: 132.33333333333334,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 211,
    x2: 211,
    y1: 165.66666666666669,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    x2: 211,
    y1: 165.66666666666669,
    y2: 165.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    x2: 207,
    y1: 132.33333333333334,
    y2: 165.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 405,
    x2: 407,
    y1: 198,
    y2: 199,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 507,
    x2: 407,
    y1: 199,
    y2: 199,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 405,
    x2: 407,
    y1: 100,
    y2: 99,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 507,
    x2: 407,
    y1: 99,
    y2: 99,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 403,
    x2: 407,
    y1: 132.33333333333334,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 407,
    x2: 407,
    y1: 132.33333333333334,
    y2: 165.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 403,
    x2: 403,
    y1: 165.66666666666669,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 407,
    x2: 403,
    y1: 165.66666666666669,
    y2: 165.66666666666669,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 209,
    x2: 209,
    y1: 1,
    y2: 100,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 405,
    x2: 209,
    y1: 100,
    y2: 100,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 405,
    x2: 405,
    y1: 1,
    y2: 100,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 407,
    x2: 407,
    y1: 99,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 407,
    x2: 407,
    y1: 165.66666666666669,
    y2: 199,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 511,
    x2: 511,
    y1: 101,
    y2: 197,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 507,
    x2: 507,
    y1: 99,
    y2: 199,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 405,
    x2: 405,
    y1: 198,
    y2: 297,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 209,
    x2: 405,
    y1: 198,
    y2: 198,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 209,
    x2: 209,
    y1: 297,
    y2: 198,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    x2: 207,
    y1: 165.66666666666669,
    y2: 199,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    x2: 207,
    y1: 99,
    y2: 132.33333333333334,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 103,
    y1: 101,
    y2: 197,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 107,
    x2: 107,
    y1: 99,
    y2: 199,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 404,
    x2: 405,
    y1: 0,
    y2: 1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    x2: 209,
    y1: 199,
    y2: 198,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwoPiecesTrayBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/two-pieces-tray-box.21d08fa4.svg";
export { ForwardRef as ReactComponent };